import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
const AddModalPlanOptions = ({ setShowModal, title, buttonName,
     setRecheck, reCheck, data,id
     , setSettingModal,setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();


    const [allValues, setAllValues] = useState({
        Description: data ? data?.description : '',
       

    });
    const [allValuesError, setAllValuesError] = useState({
        Description: false,
     

    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };


    const addAdmin = async () => {

        setSnipper(true)


       
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("plan/InsertPlanOption", "post", {
                Description: allValues?.Description,
               PlanId:id

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                setShowModal(false)
                setData(dataUser?.data)
                // setSettingModal(true)
                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");

            }
            else {
                console.log(allValuesError)
                setEroor(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    
    }
    const editAdmin = async () => {
     
        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("plan/UpdatePlanOption", "put", {
                PlanId: data?.planId,
                Description: allValues?.Description,
            
            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setEroor(dataUser.data);

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o!="Discount") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
  return (
  <>
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
      <div className="relative w-[50%] my-5 mx-auto ">
        <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
            <button onClick={() => setShowModal(false)} aria-label="Close">
              <Cross />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
          

            {/* Description */}
            <div className="col-span-1 mb-[10px] flex flex-col">
              <span className="text-[15px] font-IRANYekanBold mb-1">توضیحات</span>
              <input
                className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                type="text"
                name="Description"
                placeholder="توضیحات را اینجا بنویسید"
                value={allValues.Description}
                onChange={changeHandler}
                onBlur={blurHandler}
                onInput={maxLengthCheck}
                maxLength={200}
              />
              {allValuesError?.Description ? (
                <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                  لطفا توضیحات را وارد نمایید!
                </span>
              ) : null}
            </div>

        
          </div>

          <div className="flex justify-center">
            <button onClick={() => setShowModal(false)}>
              <p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p>
            </button>
            <button
              onClick={() => (title === "ویرایش" ? editAdmin() : addAdmin())}
              className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"
            >
              <p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p>
            </button>
          </div>
        </div>
      </div>

      {showErrorModalStep1 ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                  <span className="text-base font-bold text-red">درخواست اشتباه!</span>
                </div>

                <div className="relative px-4 py-1 flex-auto">
                  <p className="my-4 text-black text-sm leading-relaxed">{error}</p>
                </div>

                <div className="flex items-center justify-end border-solid border-slate-200 rounded-b">
                  <Link
                    className="text-white mx-4 mb-2 rounded-md shadow-blueShadow bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowErrorModalStep1(false)}
                  >
                    فهمیدم
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </div>

    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </>
);

}

export default AddModalPlanOptions;